<button
  class="btn btn-{{ color }} {{ btnAddClass }}"
  type="button"
  [disabled]="disabled"
>
  <i *ngIf="iconClass || loading" [class]="!loading ? iconClass : 'fa fa-spinner-third fa-spin'"></i>
  {{ text | translate }}
</button>
